import React from 'react';
import { TransitionGroup } from 'react-transition-group';

import { goToSectionSelected } from '../../../actions/contentItemActions';
import { useAppDispatch } from '../../../hooks/useAppDispatch';
import { getItemByIdTypedSelector } from '../../../store/reducers/items/itemsSelectors';
import { getCurrentItem } from '../../../store/selectors/getCurrentItem';
import { useStudentSelector } from '../../../store/selectors/useStudentSelector';
import { FroalaEditorsSettings } from 'src/config/configs';
import { SequencedContentFlow, SequencedContentFlowProps } from './SequencedContentFlow';
import { isSectionOrSequencedFlow, isSequencedFlowContentItem, isSequencedFlowItem, Section } from '@ael/core-api';

export const SequencedContentFlowWrapper: React.FC<{ froalaEditorsSettings: FroalaEditorsSettings }> = ({ froalaEditorsSettings }) => {
  const getItemByIdTyped = useStudentSelector(getItemByIdTypedSelector);
  const dispatch = useAppDispatch();
  const currentSequencedFlowPosition = useStudentSelector((state) => state.currentSequencedFlowPosition);
  const currentItem = useStudentSelector(getCurrentItem);
  if (!!currentItem && isSequencedFlowItem(currentItem)) {
    const currentContentItemId = currentSequencedFlowPosition.current;
    const currentSectionItemId = currentSequencedFlowPosition.currentSection || currentItem.id;
    const props: SequencedContentFlowProps = {
      currentContentItem: currentContentItemId
        ? getItemByIdTyped(currentContentItemId, isSequencedFlowContentItem)
        : null,
      currentSectionItem: getItemByIdTyped(currentSectionItemId, isSectionOrSequencedFlow),
      history: currentSequencedFlowPosition.history,
      sequencedFlowItem: currentItem,
      sequencedContentFlowStructure: currentSequencedFlowPosition.structure,
      onGoToSection: (section: Section) => dispatch(goToSectionSelected(section)),
      froalaEditorsSettings,
    };
    return <SequencedContentFlow {...props} />;
  } else {
    return <TransitionGroup />;
  }
};
